import { render, staticRenderFns } from "./SideBarNav.vue?vue&type=template&id=6c8207e3&"
import script from "./SideBarNav.vue?vue&type=script&lang=js&"
export * from "./SideBarNav.vue?vue&type=script&lang=js&"
import style0 from "./SideBarNav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cognatis/api/frontend/foundation/dev/webapp/vue-project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6c8207e3', component.options)
    } else {
      api.reload('6c8207e3', component.options)
    }
    module.hot.accept("./SideBarNav.vue?vue&type=template&id=6c8207e3&", function () {
      api.rerender('6c8207e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/SideBarNav.vue"
export default component.exports